import { Box, BoxProps } from "@chakra-ui/react";

export function FileIcon({
  color = "#518B8A",
  ...props
}: BoxProps & { width?: string; height?: string; color?: string }) {
  return (
    <Box
      as="span"
      display="inline-flex"
      alignItems="center"
      lineHeight="1"
      marginRight="-2px"
      {...props}
    >
      <svg
        width={props.width || "32"}
        height={props.height || "33"}
        viewBox="0 0 32 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: "block" }}
      >
        <path
          d="M4.66666 13.8334C4.66666 8.80504 4.66666 6.29088 6.32638 4.72878C7.98611 3.16669 10.6574 3.16669 16 3.16669H17.0303C21.3786 3.16669 23.5527 3.16669 25.0626 4.23047C25.4952 4.53526 25.8792 4.89672 26.2031 5.30387C27.3333 6.72492 27.3333 8.77116 27.3333 12.8637V16.2576C27.3333 20.2085 27.3333 22.1839 26.7081 23.7617C25.7029 26.2981 23.5771 28.2988 20.8822 29.2449C19.2058 29.8334 17.1069 29.8334 12.9091 29.8334C10.5103 29.8334 9.31094 29.8334 8.35303 29.4971C6.81305 28.9565 5.59832 27.8132 5.02394 26.3638C4.66666 25.4623 4.66666 24.3334 4.66666 22.0758V13.8334Z"
          stroke={color}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M27.3333 16.5C27.3333 18.9546 25.3435 20.9444 22.8889 20.9444C22.0012 20.9444 20.9546 20.7889 20.0915 21.0202C19.3246 21.2256 18.7256 21.8246 18.5202 22.5915C18.2889 23.4546 18.4444 24.5012 18.4444 25.3889C18.4444 27.8435 16.4546 29.8333 14 29.8333"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6667 9.83331H20"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6667 15.1667H14.6667"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  );
}
